import type { ShopDetails } from '@/lib/content';
import raw from './shop-details.json';

// The JSON's inferred type is the current values (e.g. company: null); the
// contract is the validator's output type.
const details = raw as ShopDetails;

/**
 * The facts about the shop. Most are edited by the owners at /admin
 * (content/shop.json, validated into shop-details.json by
 * scripts/build-content.mjs): phone, email, address, hours, delivery terms,
 * halal, parking, the provisional-menu switch and the FSA establishment id.
 *
 * Fixed here: the name, the map coordinates and the founding year. The
 * coordinates were geocoded from "268 High Street, Aldershot, GU12 4LT" via
 * Nominatim on 2026-09-02 and cross-checked against the postcodes.io centroid;
 * if the shop ever moves, re-geocode and change them here, since the address
 * text in the editor does not move the map pin.
 *
 * PLACEHOLDER: the phone number in content/shop.json is an obviously fake one
 * until the business line exists; the owners replace it in the editor. The
 * delivery bands, time aim and ordering terms there are drafts for the owners
 * to confirm, and delivery is switched off until they do.
 */
export const SHOP = {
  name: "Kelly's Grill",
  trading: details.trading,
  openingDate: details.openingDate,
  street: details.street,
  town: details.town,
  postcode: details.postcode,
  phone: details.phone,
  phoneHref: details.phoneHref,
  whatsappHref: details.whatsappHref,
  email: details.email,
  lat: 51.2459528,
  lng: -0.7546494,
  delivery: details.delivery,
  halal: details.halal,
  parkingNote: details.parkingNote,
  // The hygiene rating renders nothing until this is set and the FSA answers;
  // the number itself is never typed in, only fetched.
  fsaEstablishmentId: details.fsaEstablishmentId,
  // Null for a sole trader; a limited company's legal identity for the footer.
  company: details.company,
  established: '2026',
} as const;
